class MoAuditStickyBuy extends HTMLElement {
  constructor() {
    super();
    this.scheduleSync = this.scheduleSync.bind(this);
    this.submit = this.submit.bind(this);
    this.frame = null;
  }

  connectedCallback() {
    if (this.connected) return;
    this.button = this.querySelector('[data-sticky-submit]');
    this.price = this.querySelector('[data-sticky-price]');
    if (!this.button || !this.price) return;
    this.connected = true;
    this.overlaySelector = 'cart-drawer.active, dialog[open], modal-dialog[open], product-media-modal[open], .product-media-modal[open], .quick-add-modal[open], details-modal[open], details-modal details[open]';
    this.observer = new MutationObserver(this.scheduleSync);
    this.overlayObserver = new MutationObserver(records => {
      const root = document.getElementById(`MainProduct-${this.dataset.section}`);
      const form = document.getElementById(`product-form-${this.dataset.section}`);
      const relevant = root !== this.root || form !== this.form || records.some(record => {
        if (record.type === 'attributes') {
          if (record.attributeName === 'class') return record.target.matches('cart-drawer');
          return record.target.matches('dialog, modal-dialog, product-media-modal, .product-media-modal, .quick-add-modal, details-modal, details-modal details');
        }
        return [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 && (node.matches(this.overlaySelector) || node.querySelector(this.overlaySelector)));
      });
      if (relevant) this.scheduleSync();
    });
    this.overlayObserver.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['open', 'class'] });
    this.resizeObserver = new ResizeObserver(this.scheduleSync);
    this.resizeObserver.observe(this);
    this.button.addEventListener('click', this.submit);
    window.addEventListener('scroll', this.scheduleSync, { passive: true });
    window.addEventListener('resize', this.scheduleSync);
    this.sync();
  }

  scheduleSync() {
    if (!this.connected || this.frame !== null) return;
    this.frame = requestAnimationFrame(() => {
      this.frame = null;
      if (this.connected) this.sync();
    });
  }

  sync() {
    const root = document.getElementById(`MainProduct-${this.dataset.section}`);
    if (root !== this.root) {
      this.observer.disconnect();
      this.root = root;
      if (root) this.observer.observe(root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class', 'hidden'] });
    }
    this.form = document.getElementById(`product-form-${this.dataset.section}`);
    const main = this.root?.contains(this.form) ? this.form?.querySelector('[name="add"]') : null;
    const disabled = !main || main.disabled || main.getAttribute('aria-disabled') === 'true' || main.classList.contains('loading');
    if (this.button.disabled !== disabled) this.button.disabled = disabled;
    if (main) {
      const sale = this.root.querySelector('[id^="price-"] .price--on-sale');
      const price = sale ? this.root.querySelector('[id^="price-"] .price-item--sale') : this.root.querySelector('[id^="price-"] .price__regular .price-item--regular');
      const priceText = price?.textContent.trim() || '';
      const label = main.querySelector('span')?.textContent.trim() || main.textContent.trim();
      if (this.price.textContent !== priceText) this.price.textContent = priceText;
      if (this.button.textContent !== label) this.button.textContent = label;
    }
    const box = main?.getBoundingClientRect();
    const mainVisible = box && box.width > 0 && box.height > 0 && box.top >= 0 && box.bottom <= window.innerHeight && box.left >= 0 && box.right <= window.innerWidth;
    const hidden = !main || window.innerWidth > 749 || Boolean(document.querySelector(this.overlaySelector)) || Boolean(mainVisible);
    if (this.hidden !== hidden) this.hidden = hidden;
    const visible = !hidden;
    if (document.body.classList.contains('mo-pdp-sticky-visible') !== visible) document.body.classList.toggle('mo-pdp-sticky-visible', visible);
    const height = `${visible ? Math.ceil(this.getBoundingClientRect().height) : 0}px`;
    if (document.body.style.getPropertyValue('--mo-pdp-sticky-height') !== height) document.body.style.setProperty('--mo-pdp-sticky-height', height);
  }

  submit() {
    if (!this.connected) return;
    this.sync();
    if (this.hidden || this.button.disabled || !this.form?.isConnected) return;
    const main = this.form.querySelector('[name="add"]');
    if (!main || main.disabled || main.getAttribute('aria-disabled') === 'true' || main.classList.contains('loading')) return;
    this.form.requestSubmit(main);
  }

  disconnectedCallback() {
    this.connected = false;
    this.observer?.disconnect();
    this.overlayObserver?.disconnect();
    this.resizeObserver?.disconnect();
    if (this.frame !== null) cancelAnimationFrame(this.frame);
    this.frame = null;
    this.root = null;
    this.form = null;
    this.button?.removeEventListener('click', this.submit);
    window.removeEventListener('scroll', this.scheduleSync);
    window.removeEventListener('resize', this.scheduleSync);
    document.body.classList.remove('mo-pdp-sticky-visible');
    document.body.style.removeProperty('--mo-pdp-sticky-height');
  }
}
if (!customElements.get('mo-audit-sticky-buy')) customElements.define('mo-audit-sticky-buy',MoAuditStickyBuy);
document.addEventListener('click',async event=>{
  const button=event.target.closest('[data-mo-cookie-settings]');
  if (!button) return;
  if (window.privacyBanner?.showPreferences) window.privacyBanner.showPreferences();
  else if (window.Shopify?.privacyBanner?.showPreferences) window.Shopify.privacyBanner.showPreferences();
  else window.location.href=button.dataset.fallback;
});
